import { createListenerMiddleware } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import actionsDispatched from './ActionsDispatched';
import config from './Config';
import abstractedProducts from './Products';
import purchaseMotionsByLocation from './PurchaseMotionsByLocation';
import queryParamTerm from './QueryParamTerm';
import requests from './Requests';
import { upgradePageViewReducer as upgradePageView } from './UpgradePageView';
export const rootReducer = combineReducers({
  requests,
  actionsDispatched,
  abstractedProducts,
  config,
  purchaseMotionsByLocation,
  queryParamTerm,
  upgradePageView
});

// This type represents the state of your root reducer,
// and can be useful when creating selectors
export const createAppListenerMiddleware = createListenerMiddleware;

// Should be used in place of useDispatch throughout the application
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;